import { useState, useEffect, type ReactElement } from 'react'
// import { useRouter } from 'next/router'
// import Link from 'next/link'
import { Grid, Box } from '@mui/material'
// import css from './styles.module.css'
import AddInheritors from '@/components/set-up-inheritance/AddInheritors'
import SetInheritanceRules from '@/components/set-up-inheritance/SetInheritanceRules'
import PrepareInheritance from '@/components/set-up-inheritance/PrepareInheritance'
// import ConfirmInheritance from '@/components/set-up-inheritance/ConfirmInheritance'
import StepperDesktop from '@/components/set-up-inheritance/StepperDesktop'
import { StepStatus } from '@/components/set-up-inheritance/StepperDesktop'
// import { H1, SubTitle } from '@/components/typography'
import { useAppSelector } from '@/store'
import useDesktop from '@/hooks/useDesktop'
import TransactionLayout from '@/components/common/TransactionLayout/TransactionLayout'
import PageCard from '@/components/common/PageCard'
import { selectInheritanceStep } from '@/store/setUpInheritorsV2Slice'
import useChainId from '@/hooks/useChainId'
import useSafeAddress from '@/hooks/useSafeAddress'

const SetUpInheritance = (): ReactElement => {
  const isDesktop = useDesktop()
  // const router = useRouter()
  const chainId = useChainId()
  const safeAddress = useSafeAddress()
  const chainIdAddress = `${chainId}_${safeAddress}`

  const inheritanceStep = useAppSelector((state) => selectInheritanceStep(state, chainIdAddress))

  const { activeStep } = inheritanceStep
  const isDoneStep1 = inheritanceStep.step1.isDone
  const isDoneStep2 = inheritanceStep.step2.isDone
  const isDoneStep3 = inheritanceStep.step3.isDone

  // rule type: 0 = undefined, 1 = specific date, 2 = inactivity period
  const [stepData, setStepData] = useState({
    step1: {
      status: StepStatus.IN_PROGRESS,
    },
    step2: {
      status: StepStatus.TODO,
    },
    step3: {
      status: StepStatus.TODO,
    },
  })

  useEffect(() => {
    const newStepData = Object.assign({}, stepData)

    if (activeStep === 0) {
      newStepData.step1.status = StepStatus.IN_PROGRESS
      newStepData.step2.status = isDoneStep2 ? StepStatus.COMPLETED : StepStatus.TODO
      newStepData.step3.status = isDoneStep3 ? StepStatus.COMPLETED : StepStatus.TODO
    }
    if (activeStep === 1) {
      newStepData.step2.status = StepStatus.IN_PROGRESS
      newStepData.step3.status = isDoneStep3 ? StepStatus.COMPLETED : StepStatus.TODO
      newStepData.step1.status = isDoneStep1 ? StepStatus.COMPLETED : StepStatus.TODO
    }
    if (activeStep === 2 || activeStep === 3) {
      newStepData.step3.status = StepStatus.IN_PROGRESS
      newStepData.step2.status = isDoneStep2 ? StepStatus.COMPLETED : StepStatus.TODO
      newStepData.step1.status = isDoneStep1 ? StepStatus.COMPLETED : StepStatus.TODO
    }
    setStepData(newStepData)
  }, [activeStep])

  const renderStep = (step: number) => {
    switch (step) {
      case 0:
        return <AddInheritors key={`step_${step}`} chainIdAddress={chainIdAddress} inheritanceStep={inheritanceStep} />
      case 1:
        return (
          <SetInheritanceRules
            key={`step_${step}`}
            stepTitle="2. Set inheritance rules"
            chainIdAddress={chainIdAddress}
            inheritanceStep={inheritanceStep}
          />
        )
      case 2:
        return (
          <PrepareInheritance key={`step_${step}`} chainIdAddress={chainIdAddress} inheritanceStep={inheritanceStep} />
        )
      default:
        return <AddInheritors key={`step_${step}`} chainIdAddress={chainIdAddress} inheritanceStep={inheritanceStep} />
    }
  }

  const { step1, step2, step3 } = stepData

  return (
    <TransactionLayout>
      <PageCard title={isDesktop ? 'Set Up Inheritance' : `Set Up Inheritance (${activeStep + 1}/3)`} backBtn>
        <Grid container px={isDesktop ? '16px' : '0px'} pt="16px">
          <Grid item xs={12} sm={8}>
            <Box>{renderStep(activeStep)}</Box>
          </Grid>
          {isDesktop && (
            <Grid item xs={12} sm={4} pl="64px">
              <StepperDesktop stepStatus={[step1.status, step2.status, step3.status]} chainIdAddress={chainIdAddress} />
            </Grid>
          )}
        </Grid>
      </PageCard>
    </TransactionLayout>
  )
}

export default SetUpInheritance
